import React, { useState } from 'react';
import '../AskAi.scss';
import { useEffectAsync } from '@Helper/Infra';
import { CoreServices } from '@Helper/CoreServices';
import {
  AiHistoryList,
  ContentResponse,
  HistoryResponse,
} from '@Helper/Interfaces';
import moment from 'moment';
import { MessageHolder } from './GeneralTab';

type IProps = {
  historyType: string;
  goToContent: (id: string, messageHolder: MessageHolder[]) => void;
};

const HistoryBox = ({ historyType, goToContent }: IProps) => {
  const coreServices = new CoreServices();
  const [historyList, setHistoryList] = useState<AiHistoryList[]>([]);
  useEffectAsync(async () => {
    const data = (await coreServices.getHistoryType(
      historyType
    )) as HistoryResponse;
    setHistoryList(data.rows);
    console.log('data', data);
  }, [historyType]);

  return (
    <div style={{ marginTop: 15 }}>
      <div className="history-content">
        {historyList.map(i => {
          return (
            <div
              key={i.id}
              className="history-item"
              onClick={async () => {
                const resp = (await coreServices.getContent(
                  i.id
                )) as ContentResponse[];
                const messageHolder = [] as MessageHolder[];
                for (const item of resp) {
                  const userHolder = {
                    from: 'user',
                    type: 'message',
                    message: item.prompt,
                  } as MessageHolder;
                  const responseHolder = {
                    from: 'ai',
                    type: 'message',
                    message: item.response,
                  } as MessageHolder;
                  messageHolder.push(userHolder);
                  messageHolder.push(responseHolder);
                }
                goToContent(i.id, messageHolder);
              }}
            >
              <div className="date">
                {moment(i.createdAt).format('MM/DD/YYYY HH:MM:SS')}
              </div>
              <div className="history-body">
                <div className="tag">{i.queryType}</div>
                <div className="text">{i.name}</div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default HistoryBox;
